import React from 'react';
import ReactModal from 'react-modal';

// DEPRECATED: use src/components/dialog/ConfirmationDialog.component.jsx
const ConfirmationDialog = ({
  title,
  leftButtonText,
  onLeft,
  rightButtonText,
  onRight,
  onCancel,
  children,
  showHeader = true,
  disableConfirm = false,
}) => (
  <ReactModal
    isOpen
    onRequestClose={onCancel}
    closeTimeoutMS={0}
    contentLabel={title}
    ariaHideApp
    shouldCloseOnOverlayClick
    role="dialog"
    style={{
      overlay: {
        zIndex: 500,
      },
    }}
    className={{
      base: 'dialog-container',
      afterOpen: 'dialog-container',
      beforeClose: 'dialog-container',
    }}
  >
    <div data-bem="ConfirmationDialog__content--checkout" className="dialog">
      {showHeader && (
        <div className="dialog-header">
          <h2>{title}</h2>
          <div className="close" role="button" tabIndex={0} onClick={onCancel} />
        </div>
      )}
      <div className="body">{children}</div>
      <div className="dialog-footer">
        <div data-cy="confirm-left-button" className="btn btn-violet-link" role="button" tabIndex={0} onClick={onLeft}>
          {leftButtonText}
        </div>
        <div
          data-cy="confirm-right-button"
          className={showHeader ? 'btn btn-violet' : 'btn btn-violet-link'}
          role="button"
          tabIndex={0}
          onClick={onRight}
          disabled={disableConfirm}
        >
          {rightButtonText}
        </div>
      </div>
    </div>
  </ReactModal>
);

export default ConfirmationDialog;
